module.exports = __webpack_public_path__ + "static/media/nav-icon-strength-acive.83ff929e.svg";